/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Users_TitleInputs */



/**
* | output |
* | --- |
* | "Add users to your team" |
*
* @param {Team_Manager_Add_Users_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_users_title = /** @type {((inputs?: Team_Manager_Add_Users_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Users_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter des utilisateurs à l'équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer zum Team hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi utenti al team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить пользователей в команду")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir usuarios al equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向团队添加用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームにユーザーを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम में उपयोगकर्ता जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar utilizadores à equipa")
	return /** @type {LocalizedString} */ ("Add users to your team")
});